import apiService from '../apiService'

export const supplierController = configService => {
  const service = apiService(configService)

  return {
    supplierList: params => {
      return service.post({
        url: `cms/buyer/mySupplier`,
        params,
      })
    },

    addSupplierListId: id => {
      return service.get({
        url: `cms/buyer/addToMySupplier/${id}`,
      })
    },

    supplierListId: id => {
      return service.get({
        url: `cms/buyer/mySupplier/${id}`,
      })
    },

    supplierSustainability: id => {
      return service.get({
        url: `cms/supplier/${id}/sustain`,
      })
    },

    supplierRegulatory: id => {
      return service.get({
        url: `cms/buyer/regulatory/${id}`,
      })
    },

    mainDirectoryList: params => {
      return service.post({
        url: `cms/buyer/getSupplier`,
        params,
      })
    },

    supplierCompanyRfq: () => {
      return service.get({
        url: `cms/buyer/supplierCompanyRfq`,
      })
    },

    supplierdeleteRfq: id => {
      return service.put({
        url: `cms/buyer/deleteRfq/` + id,
      })
    },

    supplieraddToRfq: id => {
      return service.get({
        url: `cms/buyer/addToRfq/` + id,
      })
    },

    supplierNew: (id, params) => {
      return service.get({
        url: `cms/buyer/supplier/${id}/news`,
        params,
      })
    },

    supplierNewImage: params => {
      return service.getNew({
        url: `cms/supplier/newsImage`,
        params,
      })
    },

    getSupulierTag: id => {
      return service.get({
        url: `/cms/supplier/${id}/tags`,
      })
    },

    supplierUpdate: id => {
      return service.get({
        url: `/cms/buyer/mysupplier/${id}/update`,
      })
    },
  }
}

export const supplierRegisterController = configService => {
  const service = apiService(configService)
  return {
    verifyToken: token => {
      return service.verifyToken({
        url: `cms/supplier/verify`,
        token,
      })
    },

    getBusinessCategories: () => {
      return service.get({
        url: `auth/buyer/business/categories`,
      })
    },

    getBusinessSubCategories: id => {
      return service.get({
        url: `auth/buyer/business/sub_categories/${id}`,
      })
    },

    getBusinessType: () => {
      return service.get({
        url: `auth/buyer/businessType`,
      })
    },

    getCountry: () => {
      return service.get({
        url: `auth/buyer/country`,
      })
    },
    getCurrency: () => {
      return service.get({
        url: `auth/buyer/currency`,
      })
    },

    getSupplierInformation: mailKey => {
      return service.get({
        url: `auth/buyer/company/information/${mailKey}`,
      })
    },
    updateSupplierInformation: params => {
      return service.putFormDataRegis({
        url: `auth/buyer/company/information`,
        params,
      })
    },
  }
}
